module.exports = __webpack_public_path__ + "img/star.61123ba6.svg";